// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._33Ibv{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;-ms-flex:none;flex:none;height:84px;height:8.4rem;justify-content:center;margin-bottom:3.2rem;padding:1.6rem 2.4rem;width:290px;width:29rem;-ms-flex-order:0;order:0;-ms-flex-item-align:stretch;align-self:stretch;-ms-flex-positive:0;background:#101010;border-radius:16px;flex-grow:0}._1PeC0{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:justify;color:#fff;justify-content:space-between}", ""]);
// Exports
exports.locals = {
	"sidebar__headerContainer": "_33Ibv",
	"sidebar__headerContainer__top": "_1PeC0"
};
module.exports = exports;
